import React from "react";
import { ObservableMap } from "mobx";
import { observer } from "mobx-react";
import classNames from "classnames";


import { EventKeyBettingOffer, Player } from "@gp/models";

import { BettingData } from "@data-types/sport-stats/SportStatsTypes";
import { PlayerStatistics } from "@features/offer/shared/statistics/components/player-betting-types";

import { OfferTip } from "@features/offer/desktop/buttons";

import { bettingTypesTwoCols } from "./BettingTypeRow";

export const PlayerTipWrapper = observer(function PlayerTipWrapper(props: {
	tip?: EventKeyBettingOffer;
	bettingTypeAbrv?: string;
	players?: ObservableMap<string, Player>;
	bettingTypeStats?: BettingData[] | null;
	isStats?: boolean;
}) {
	const { tip, bettingTypeAbrv, players, bettingTypeStats } = props;
	let playerName: string;

	if (players) {
		const player = players.get(tip?.playerId || "");
		playerName = `${player?.firstName}-${player?.lastName}`;
	}

	const tipData = bettingTypeStats?.find(
		(item) => item?.playerAbrv == playerName?.toLowerCase()
	)?.data as BettingData;

	const playerTipWrapperClasses = classNames("offer__player__item", {
		"offer--additional__inline__item": !bettingTypesTwoCols.includes(
			bettingTypeAbrv || ""
		),
		"offer--additional__grid__half": bettingTypesTwoCols.includes(
			bettingTypeAbrv || ""
		),
		"offer__player__item--spacing": props.isStats,
	});

	return (
		<>
			<OfferTip
				tip={tip}
				displayTipName={tip?.displayTip}
				className={playerTipWrapperClasses}
				isGroupedOfferTip
				isPlayerMarket
				isAdditionalOffer={true}
			/>
			<PlayerStatistics
				bettingTypeAbrv={bettingTypeAbrv}
				bettingTypeStats={tipData}
			/>
		</>
	);
});
